<template>
  <button
    id="btn-copy-heading-link"
    class="btn-square pt usn bg-background-strongest hover:bg-icon-bg group"
    :style="{
      top: `${dimensions.top}px`,
      left: `${dimensions.left}px`,
    }"
    :class="{
      absolute: absolutePosition,
    }"
    @click.stop="copy(link)"
  >
    <em
      :style="getCustomIconStyle(iconPath('link-st'))"
      class="custom-icons page-toolbar bg-icon-default group-hover:bg-icon-hover"
    />
  </button>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  name: 'ButtonCopyHeadingLink',
  mixins: [customIconsMixin],
  props: {
    dimensions: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    linkId: {
      type: String,
      required: true,
      default: '',
    },
    absolutePosition: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    link() {
      return [window.location.origin, this.$route.path, '#', this.linkId].join('');
    },
  },
  methods: {
    copy(value) {
      navigator.clipboard.writeText(value);

      const notification = {
        message: this.translate('linkCopiedToClipboard'),
        icon: 'link-st',
        duration: 4000,
      };
      this.$store.dispatch('addUiNotification', notification);
    },
  },
};
</script>

<style lang="scss">
#btn-copy-heading-link {
  z-index: 1;
  &.absolute {
    position: absolute;
    top: 0px;
    left: 0px;
  }

  .page-toolbar {
    background-color: $gray400;
  }

  &:hover {
    .page-toolbar {
      background-color: $gray700;
    }
  }

  .btn-square {
    margin-top: -5px;
  }
}

.ProseMirror-resizing {
  #btn-copy-heading-link {
    display: none !important;
  }
}
</style>
